import { useAuth } from "~utils/hooks/use-auth"
import { useUser } from "~contexts/user-provider"
import { useOutfitterContext } from "~contexts/outfitter-provider"

export default function useIsOutfitterAssistantAvailable(): boolean {
    const { isAuthenticated } = useAuth()
    const { user, isLoading: isUserLoading } = useUser()
    const { outfitterId } = useOutfitterContext()

    return (
        isAuthenticated &&
        !isUserLoading &&
        Boolean(user?.id) &&
        Boolean(outfitterId)
    )
}
